module.exports = __webpack_public_path__ + "img/2009 feuerwehr winteressen 001.918ada6f.jpg";